<template>
  <div class="row sport-header">
    <div class="grid-left sport-header-name text-cut">
      <i
        class="sport-header-icon n-i"
        :class="`n-i-live-${sport.id}`"
      />
      <span class="text-upper font-italic font-bold">
        {{ sport.name }}
      </span>
      <sport-header-period :id-sport="sport.id" />
    </div>
    <div class="grid-right">
      <div
        class="sport-header-bet"
        v-for="(bet, index) in sport.bets"
        :key="index">
        <sport-header-bet-special :bet="bet" />
      </div>
    </div>
  </div>
</template>

<script>
import SportHeaderBetSpecial from '@/components/common/sport-header-bet-special/SportHeaderBetSpecial.vue';
import SportHeaderPeriod from '@/components/common/sport-header-period/SportHeaderPeriod.vue';

export default {
  name: 'SportHeader',
  components: { SportHeaderBetSpecial, SportHeaderPeriod },
  props: {
    sport: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.sport-header {
  color: $color-text-primary;
  font-weight: $font-weight-bold;
  @if $sport-header-gradient == false {
    background-color: $sport-header-color-back;
  } @else {
    background-image: $sport-header-color-back-gradient;
  }

  .sport-header-name {
    padding-left: 10px;
    font-size: 0.9375rem;
    font-weight: $font-weight-normal;
  }

  .sport-header-icon {
    font-size: 0.75rem;
  }

  .sport-header-bet {
    float: left;
    width: 20%;
  }
}

.sport-periods {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
